import type {IHttpService} from 'angular';
import {
    responseToData,
    unRestangularize
} from 'shared/utils/data-service-utils';
import type {FinishedSaveResponse, Rating} from 'typings/portaro.be.types';


/**
 * @ngdoc service
 * @name RatingDataService
 * @module uc.record
 *
 * @description
 * Service for `Rating` handling
 *
 * @requires service:$http
 */
export default class RatingDataService {
    public static readonly serviceName = 'ratingDataService';
    public static readonly RATING_ROUTE = 'rating';
    public static readonly RECORD_ROUTE = 'records';

    /*@ngInject*/
    constructor(private $http: IHttpService,
                private Restangular: Restangular.IService) {
    }

    @unRestangularize()
    public async getById(recordId: string): Promise<Rating> {
        try {
            return await this.Restangular
                .one(RatingDataService.RECORD_ROUTE, recordId)
                .one(RatingDataService.RATING_ROUTE)
                .get();
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @unRestangularize()
    public async createRating(recordId: string, value: number): Promise<FinishedSaveResponse<Rating>> {
        try {
            return await this.Restangular
                .one(RatingDataService.RECORD_ROUTE, recordId)
                .one(RatingDataService.RATING_ROUTE)
                .post(null, value);
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

}

